module.exports = __webpack_public_path__ + "img/gold1.4c0e5f9c.png";